import { render, staticRenderFns } from "./Telefone.vue?vue&type=template&id=525847cc"
import script from "./Telefone.vue?vue&type=script&lang=js"
export * from "./Telefone.vue?vue&type=script&lang=js"
import style0 from "./Telefone.vue?vue&type=style&index=0&id=525847cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports